import React from 'react';

import useMediaQuery from 'utils/useMediaQuery';
import { PartnerSlider } from 'components/PartnerSlider';
import { UspList } from 'components/UspList';
import { IUspListItem } from 'components/UspList/UspList';
import { Direction } from 'enums/Direction';
import { deal, headphonesCustomerSupport } from 'icons/default';
import { Car } from 'icons/symbol';

import styles from './Usp.module.scss';

interface Props {
  soldCars?: number;
}

export const Usp: React.FC<Props> = () => {
  const items: IUspListItem[] = [
    {
      icon: deal,
      heading: 'Ansöka om samma billån som hos bilhandlaren',
      text: 'Köp en bil på garageuppfarten med samma billån som hos bilhandlaren. Samma ränta för alla.',
      link: '/lanelofte-billan',
    },
    {
      icon: Car,
      heading: 'Lägga om din företagsleasing eller ansöka om en ny',
      text: 'Vi har hjälpt hundratals företagare att förbättra sina leasingkostnader.',
      link: '/foretag/release',
    },
    {
      icon: headphonesCustomerSupport,
      heading: 'Få experthjälp när du köper en bil på garageuppfarten',
      text: 'Personlig hjälp för en säker affär och hjälp med ägarbyte.',
      link: '/kopa-begagnad-bil',
    },
  ];

  const isMobile = useMediaQuery('(max-width: 768px)');

  return (
    <div className={styles.wrapper}>
      <div className={styles.texts}>
        <h2>
          Vi har hjälpt <span>1000-tals</span> nöjda kunder.
        </h2>

        <p>
          När du ska köpa eller sälja privat hjälper vi dig och tar hand om allt det krångliga.
          Blipp löser allt från billån, försäkring, bakgrundskontroll till betalning och
          överlämning.
        </p>
      </div>
      <div className={styles.usp}>
        <h3>Med Blipp kan du...</h3>
        {isMobile ? (
          <UspList items={items} listVariant={Direction.Vertical} />
        ) : (
          <UspList items={items} itemVariant={Direction.Vertical} />
        )}
      </div>
      <div className={styles.partners}>
        <h4>Tack vare våra partners</h4>
        <PartnerSlider />
      </div>
    </div>
  );
};
